export default __webpack_public_path__ + "static/media/so80gbp-mobile.30cf6f79.png";